import Head from 'next/head';
import { memo } from 'react';

import { getActiveDocumentTitle } from '~/components/v2/store/features/document-title/getActiveDocumentTitle';
import { useDocumentTitleStore } from '~/components/v2/store/features/document-title/useDocumentTitleStore';

const IS_SERVER = typeof window === 'undefined';

/**
 * Unmounts when no title is registered, so a store change on a page that sets its title with `NextSeo`
 * cannot re-render a `<title>` over it. On the server, `DocumentTitle` renders page titles instead,
 * because effects do not run there.
 */
export const RegisteredDocumentTitleHead = memo(() => {
  const registeredTitle = useDocumentTitleStore((state) => getActiveDocumentTitle(state.entries));

  if (IS_SERVER || !registeredTitle) {
    return null;
  }

  return (
    <Head>
      <title key="title">{registeredTitle}</title>
    </Head>
  );
});

RegisteredDocumentTitleHead.displayName = 'RegisteredDocumentTitleHead';
